<template>
  <div v-if="isOpen" class="modal fade show d-block" tabindex="-1" style="background: rgba(0, 0, 0, 0.5); z-index: 100000;" @click.self="closeModal">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable my-3 my-md-auto">
      <div class="modal-content p-3 p-md-5 animate__animated animate__fadeInUp modal-content-custom">
        <div class="modal-header border-0 pb-2">
          <div>
            <h3 class="modal-title fs-4 fw-bold">Selectează firma</h3>
            <span class="text-muted fs-8 d-block">Alege firma pe care dorești să o accesezi</span>
          </div>
          <button type="button" class="btn btn-sm btn-icon btn-active-light-primary" @click="closeModal">
            <i class="ki-duotone ki-cross fs-1"></i>
          </button>
        </div>
        <div class="modal-body py-2 px-1 px-md-3 modal-body-custom">
          <!-- Detalii firma selectata (compact pe mobil, desktop neschimbat) -->
          <div v-if="firmaSelectata && firmaSelectataObj" class="mb-4 p-3 p-md-4 border rounded bg-light">
            <h5 class="fw-bold fs-6 mb-2 text-primary">Firmă activă selectată:</h5>
            <div class="d-flex flex-wrap gap-2 gap-md-4 fs-7">
              <div><strong>Denumire:</strong> {{ firmaSelectataObj.denumire }}</div>
              <div><strong>CUI:</strong> {{ firmaSelectataObj.cui }}</div>
              <div v-if="firmaSelectataObj.reg_com"><strong>Reg. Com:</strong> {{ firmaSelectataObj.reg_com }}</div>
              <div>
                <strong>Status:</strong>
                <span class="badge ms-1" :class="getStareFirmaBadge(firmaSelectataObj.stare_firma).class">
                  {{ getStareFirmaBadge(firmaSelectataObj.stare_firma).text }}
                </span>
              </div>
            </div>
          </div>

          <!-- Grid Firme Disponibile -->
          <div class="row g-3" data-kt-buttons="true">
            <div class="col-12 col-md-4 mb-1 mb-md-3" v-for="firma in firmeDisponibile" :key="firma.id">
              <div class="position-relative h-100">
                <div v-if="firma.autologin_firma" class="position-absolute top-0 end-0">
                  <span class="ribbon-right bg-danger text-white">Auto Login</span>
                </div>
                <label
                  class="btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-3 p-md-5 h-100 w-100 firma-card-label"
                  :class="{ active: firmaSelectata === firma.id }">
                  <div class="d-flex align-items-center me-2 w-100">
                    <div class="form-check form-check-custom form-check-solid form-check-primary me-3 me-md-4 flex-shrink-0">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="firma_selectata"
                        :value="firma.id"
                        v-model="firmaSelectata"
                      />
                    </div>
                    <div class="flex-grow-1 min-w-0">
                      <h4 class="fs-6 fw-bold mb-1 text-dark text-break lh-sm">
                        {{ firma.denumire }}
                      </h4>
                      <div class="mb-2 d-flex flex-wrap gap-1 align-items-center">
                        <span
                          class="badge fs-8 px-2 py-1"
                          :class="roluriFirma[firma.rol]?.class || 'badge-secondary'"
                        >
                          {{ roluriFirma[firma.rol]?.text || 'Rol necunoscut' }}
                        </span>
                        <span
                          class="badge fs-8 px-2 py-1"
                          :class="getStareFirmaBadge(firma.stare_firma).class"
                        >
                          {{ getStareFirmaBadge(firma.stare_firma).text }}
                        </span>
                      </div>
                      <div class="fw-semibold text-muted fs-7">
                        CUI: <span class="text-dark">{{ firma.cui }}</span>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 pt-3 d-flex justify-content-between">
          <button class="btn btn-light fw-bold" @click="closeModal">Închide</button>
          <button class="btn btn-primary fw-bold px-5" :disabled="!firmaSelectata" @click="confirmaSchimbareFirma">
            <i class="fa-solid fa-check me-1"></i> Schimbă firma
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { getStareFirmaBadge } from '../../consts/firmaStatus';
import { useUserStore } from '../../stores/user';

export default {
  name: 'ModalSchimbaFirme',
  props: {
    uid: {
      type: [String, Number],
      default: null
    },
    afiseaza: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  data() {
    return {
      isOpen: this.afiseaza,
      firmeDisponibile: [],
      firmaSelectata: null,
      firmaSelectataObj: null,
      roluriFirma: {
        1: { text: 'Vizualizare', class: 'badge-success' },
        2: { text: 'Operator', class: 'badge-primary' },
        3: { text: 'Editare', class: 'badge-info' },
        4: { text: 'Administrare', class: 'badge-warning' },
        5: { text: 'Detinator', class: 'badge-danger' },
      }
    };
  },
  computed: {
    effectiveUid() {
      return this.uid || this.userStore.user?.id || window.initialUserData?.id || null;
    }
  },
  mounted() {
    window.addEventListener('open-modal-schimba-firme', this.onOpenEvent);
  },
  beforeUnmount() {
    window.removeEventListener('open-modal-schimba-firme', this.onOpenEvent);
  },
  created() {
    if (this.isOpen || this.afiseaza) {
      this.incarcaFirmeUtilizator(this.effectiveUid);
    }
  },
  watch: {
    afiseaza(newVal) {
      this.isOpen = newVal;
    },
    isOpen(newVal) {
      if (newVal) {
        this.incarcaFirmeUtilizator(this.effectiveUid);
      }
    },
    firmaSelectata(newVal) {
      if (newVal) {
        this.firmaSelectataObj = this.firmeDisponibile.find(f => f.id === newVal);
      } else {
        this.firmaSelectataObj = null;
      }
    }
  },
  methods: {
    getStareFirmaBadge, // expose imported method
    onOpenEvent() {
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
      this.$emit('inchide');
    },
    async incarcaFirmeUtilizator(uid) {
      const targetUid = uid || this.effectiveUid;
      if (!targetUid) return;
      try {
        const response = await axios.get(`/api/cont/firme-utilizator/${targetUid}`);
        this.firmeDisponibile = response.data.firme;
        const curenta = response.data.firma_curenta;
        if (curenta) {
          this.firmaSelectata = curenta;
        }
      } catch (error) {
        console.error('Eroare la încărcarea firmelor:', error);
      }
    },
    confirmaSchimbareFirma() {
      if (!this.firmaSelectata) return;
      axios.post('/api/cont/schimba-firma', {
        firma_id: this.firmaSelectata
      }).then(() => {
        window.location.reload();
      }).catch(error => {
        console.error('Eroare la schimbarea firmei:', error);
      });
    }
  }
};
</script>

<style scoped>
.ribbon-right {
  top: 10px;
  right: 10px;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.2rem 1.2rem;
  z-index: 10;
  background-color: #dc3545;
  color: white;
  border-radius: 0.2rem;
}

@media (max-width: 768px) {
  .modal-content-custom {
    max-height: 90vh;
    border-radius: 16px;
  }
  .modal-body-custom {
    max-height: calc(90vh - 140px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .firma-card-label {
    padding: 12px !important;
    border-radius: 12px;
  }
  .ribbon-right {
    font-size: 0.75rem;
    padding: 0.1rem 0.6rem;
  }
}
</style>